import axios from "axios";

const updatePresentationVersion = async (
  presentationId: string,
  token: string | null,
  payload: {
    thumbnails: {
      id: string;
      time: string;
      title: string;
      description: string;
      width: number
    }[];
    // chapter_title: string;
    // chapter_description: string;
    date: string;
  },
  version_id: string,
  eventId: string | null
) => {
  try {
    console.log(payload, "paykaa");
    
    // Include eventId in the URL if it exists
    const url = eventId
      ? `${process.env.REACT_APP_API_ENDPOINT}/api/presentation/asspeaker/${presentationId}/version/${version_id}/chapter-edit-update?eventId=${eventId}`
      : `${process.env.REACT_APP_API_ENDPOINT}/api/presentation/asspeaker/${presentationId}/version/${version_id}/chapter-edit-update`;

    const headers: any = {
      "Content-Type": "application/json",
    };

    // Only add Authorization header if token exists
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await axios.patch(
      url,
      payload,
      { headers }
    );
    console.log("Update successful:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating presentation:", error);
    throw error;
  }
};

export default updatePresentationVersion;